import {
  FOOTBALL,
  AM_FOOTBALL,
  BASKETBALL,
  HOCKEY,
  BASEBALL,
  TENNIS,
  FIGHTING,
} from 'constants/sportIds'

export const UEFANL_LID = 1911
export const LIBERTADORES_LID = 518
export const NCAAB_LID = 14
export const NBA_LID = 5
export const WNBA_LID = 15
export const NFL_LID = 16
export const NHL_LID = 7
export const MLB_LID = 3
export const NCAAF_LID = 6
export const MLS_LID = 4
export const EPL_LID = 2
export const UCL_LID = 8
export const ATP_LID = 23
export const WTA_LID = 24
export const UFC_LID = 26
export const BOXING_LID = 48
export const CFL_LID = 19
export const AFL_LID = 18
export const WORLD_CUP_LID = 36
export const WOMEN_WORLD_CUP_LID = 597
export const EUCH_LID = 233
export const EUROPA_LID = 35
export const BUNDESLIGA = 11
export const LIGUE_1 = 9
export const EREDIVISIE = 29
export const SERIE_A = 10
export const MX_LID = 30
export const SCOTTISH_PREMIER_LID = 13
export const LA_LIGA = 17
export const LIGA_ZON_SAGRES = 33
export const AMCOP = 594
export const ARGENTINA_PRIME = 31
export const BRAZIL_SERIA_A = 32
export const CONCACAF = 45
export const FRIENDLY_INT = 38
export const NORWAY_TIPPELIGAENE = 46
export const SWEDEN_ALLSVENSKAN = 47
export const WCAFCQ = 545
export const WCCAFQ = 544
export const WCCCAFQ = 546
export const WCCMBQ = 542
export const WCOFCQ = 618
export const WCUEFAQ = 543
export const AAF = 2345
export const BELLATOR = 50
export const AFRCN_LID = 2396
export const TURSL_LID = 418
export const RUPL_LID = 322
export const EFL_LID = 12
export const PGA_TOUR = 28
export const BUNDESLIGATWO_LID = 354
export const JLEAGUE_LID = 436
export const CSL_LID = 130
export const KLEAGUE_LID = 185

// The following variables must come in the config file.

export const leagues = [
  { lid: NHL_LID, name: 'NHL', spid: HOCKEY },
  { lid: MLB_LID, name: 'MLB', spid: BASEBALL },
  { lid: NCAAB_LID, name: 'NCAAB', spid: BASKETBALL },
  { lid: NCAAF_LID, name: 'NCAAF', spid: AM_FOOTBALL },
  { lid: NBA_LID, name: 'NBA', spid: BASKETBALL },
  { lid: NFL_LID, name: 'NFL', spid: AM_FOOTBALL },
  { lid: ATP_LID, name: 'ATP', spid: TENNIS },
  { lid: WTA_LID, name: 'WTA', spid: TENNIS },
  { lid: UFC_LID, name: 'UFC', spid: FIGHTING },
]

export const defaultSelectedLeagueId = NCAAB_LID

export const widgetDefaultLeague = leagues.find(
  (league) => league.lid === defaultSelectedLeagueId,
)

export const leaguesPages = {
  [SCOTTISH_PREMIER_LID]: 'scottish-premier-league',
  [SWEDEN_ALLSVENSKAN]: 'sweden-allsvenskan',
  [FRIENDLY_INT]: 'friendly-international',
  [LIBERTADORES_LID]: 'copa-libertadores',
  [LIGA_ZON_SAGRES]: 'liga-zon-sagres',
  [ARGENTINA_PRIME]: 'argentina-prime',
  [UEFANL_LID]: 'uefa-nations-league',
  [EPL_LID]: 'english-premier-league',
  [EUCH_LID]: 'european-championship',
  [BRAZIL_SERIA_A]: 'brazil-serie-a',
  [MLS_LID]: 'major-league-soccer',
  [NCAAF_LID]: 'college-football',
  [NCAAB_LID]: 'ncaa-basketball',
  [WNBA_LID]: 'wnba-basketball',
  [UCL_LID]: 'champions-league',
  [EUROPA_LID]: 'europa-league',
  [WORLD_CUP_LID]: 'world-cup',
  [WOMEN_WORLD_CUP_LID]: 'womens-world-cup',
  [NBA_LID]: 'nba-basketball',
  [AFL_LID]: 'arena-football',
  [BUNDESLIGA]: 'bundesliga',
  [EREDIVISIE]: 'eredivisie',
  [NFL_LID]: 'nfl-football',
  [MLB_LID]: 'mlb-baseball',
  [CFL_LID]: 'cfl-football',
  [MX_LID]: 'liga-mexicana',
  [NHL_LID]: 'nhl-hockey',
  [ATP_LID]: 'atp-tennis',
  [WTA_LID]: 'wta-tennis',
  [BOXING_LID]: 'boxing',
  [CONCACAF]: 'concacaf',
  [SERIE_A]: 'serie-a',
  [LA_LIGA]: 'la-liga',
  [WCCCAFQ]: 'wcccafq',
  [WCUEFAQ]: 'wcuefaq',
  [LIGUE_1]: 'ligue1',
  [WCAFCQ]: 'wcafcq',
  [WCCAFQ]: 'wccafq',
  [WCCMBQ]: 'wccmbq',
  [WCOFCQ]: 'wcofcq',
  [AMCOP]: 'amcop',
  [UFC_LID]: 'ufc',
  [PGA_TOUR]: 'pga-tour',
  [BELLATOR]: 'bellator',
  [AAF]: 'alliance-american-football',
  [AFRCN_LID]: 'africa-cup-of-nations',
  [TURSL_LID]: 'turkish-super-lig',
  [RUPL_LID]: 'russian-premier-league',
  [EFL_LID]: 'england-championship',
  [BUNDESLIGATWO_LID]: 'bundesliga-2',
  [JLEAGUE_LID]: 'japan-league-1',
  [CSL_LID]: 'chinese-super-league',
  [KLEAGUE_LID]: 'korean-league-one',
}

export const bmrLeaguesPages = {
  [SCOTTISH_PREMIER_LID]: 'scottish-premier-league',
  [SWEDEN_ALLSVENSKAN]: 'sweden-allsvenskan',
  [FRIENDLY_INT]: 'friendly-international',
  [LIBERTADORES_LID]: 'copa-libertadores',
  [LIGA_ZON_SAGRES]: 'liga-zon-sagres',
  [ARGENTINA_PRIME]: 'argentina-prime',
  [UEFANL_LID]: 'uefa-nations-league',
  [EPL_LID]: 'english-premier-league',
  [EUCH_LID]: 'european-championship',
  [BRAZIL_SERIA_A]: 'brazil-serie-a',
  [MLS_LID]: 'major-league-soccer',
  [NCAAF_LID]: 'ncaaf',
  [NCAAB_LID]: 'ncaab',
  [WNBA_LID]: 'wnba-basketball',
  [UCL_LID]: 'champions-league',
  [EUROPA_LID]: 'europa-league',
  [WORLD_CUP_LID]: 'world-cup',
  [WOMEN_WORLD_CUP_LID]: 'womens-world-cup',
  [NBA_LID]: 'nba',
  [AFL_LID]: 'arena-football',
  [BUNDESLIGA]: 'bundesliga',
  [EREDIVISIE]: 'eredivisie',
  [NFL_LID]: 'nfl',
  [MLB_LID]: 'mlb',
  [CFL_LID]: 'cfl-football',
  [MX_LID]: 'liga-mexicana',
  [NHL_LID]: 'nhl',
  [ATP_LID]: 'atp-tennis',
  [WTA_LID]: 'wta-tennis',
  [BOXING_LID]: 'boxing',
  [CONCACAF]: 'concacaf',
  [SERIE_A]: 'serie-a',
  [LA_LIGA]: 'la-liga',
  [WCCCAFQ]: 'wcccafq',
  [WCUEFAQ]: 'wcuefaq',
  [LIGUE_1]: 'ligue1',
  [WCAFCQ]: 'wcafcq',
  [WCCAFQ]: 'wccafq',
  [WCCMBQ]: 'wccmbq',
  [WCOFCQ]: 'wcofcq',
  [AMCOP]: 'amcop',
  [UFC_LID]: 'ufc',
  [PGA_TOUR]: 'pga-tour',
  [BELLATOR]: 'bellator',
  [AAF]: 'alliance-american-football',
  [AFRCN_LID]: 'africa-cup-of-nations',
  [TURSL_LID]: 'turkish-super-lig',
  [RUPL_LID]: 'russian-premier-league',
  [EFL_LID]: 'england-championship',
  [BUNDESLIGATWO_LID]: 'bundesliga-2',
  [JLEAGUE_LID]: 'japan-league-1',
  [CSL_LID]: 'chinese-super-league',
  [KLEAGUE_LID]: 'korean-league-one',
}

export const sportPages = {
  [FOOTBALL]: 'soccer',
  [AM_FOOTBALL]: 'football',
  [BASKETBALL]: 'basketball',
  [HOCKEY]: 'hockey',
  [BASEBALL]: 'baseball',
}

export const LINK_BY_LEAGUE = {
  NCAAB: 'https://www.bookmakersreview.com/ncaab/odds/',
  NBA: 'https://www.bookmakersreview.com/nba/odds/',
  NHL: 'https://www.bookmakersreview.com/nhl/odds/',
  MLB: 'https://www.bookmakersreview.com/mlb/odds/',
  NCAAF: 'https://www.bookmakersreview.com/ncaaf/odds/',
  UEFA: 'https://www.bookmakersreview.com/champions-league/odds/',
  NFL: 'https://www.bookmakersreview.com/nfl/odds/',
  WTA: 'https://www.bookmakersreview.com/wta/odds/',
  ATP: 'https://www.bookmakersreview.com/atp/odds/',
  UFC: 'https://www.bookmakersreview.com/ufc/odds/',
}
